export default "__VITE_ASSET__C7Kz5Hd7__"